import React from 'react';
import PropTypes from 'prop-types';
import AirportDateTimePickers from 'common/airport/date-pickers/AirportDateTimePickers';

const ParkingDateTimePanel = ({
    starts,
    ends,
    isFetchingRates,
    onSearchClick,
}) => {
    return (
        <div className="ParkingDateTimePanel">
            <AirportDateTimePickers
                className="SearchAirportControls-airport-date-time-pickers ParkingDateTimePanel-airport-date-time-pickers"
                startDateLabelText="Parking Check In"
                endDateLabelText="Parking Check Out"
                starts={starts}
                ends={ends}
                isLoading={isFetchingRates}
                searchButtonText="Check Availability"
                onSearchClick={onSearchClick}
            />
        </div>
    );
};

ParkingDateTimePanel.propTypes = {
    isFetchingRates: PropTypes.bool,
    starts: PropTypes.string,
    ends: PropTypes.string,
    onSearchClick: PropTypes.func.isRequired,
};

export default ParkingDateTimePanel;
